import React, { Component } from "react";

import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import ChoiceGridScroll from "../Choices/ChoiceGridScroll";
import ProductOptionGroup from "../Groups/";

class OptionGroupGrid extends Component {
  state = { isScrollable: false, containerWidth: -1 };
  handleResize = () => {
    this.setState({
      containerWidth: this.container.current?.clientWidth || -1,
    });
  };
  componentDidMount = () => {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("orientationchange", this.handleResize, true);
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("orientationchange", this.handleResize, true);
  };

  container = React.createRef();
  render() {
    const {
      option,
      selectedOptions,
      controlOptions,
      themeColor,
      language,
      discountAmount,
      productQuantity,
      productUsedComponents,
      editedProduct,
      groupID,
      optionKey,
    } = this.props;
    const containerWidth = this.state.containerWidth || 200;

    const choices = option.choices.map((choice) => (
      <Grid key={`${optionKey} ${choice.id}`} item xs={6}>
        <ChoiceGridScroll
          themeColor={themeColor}
          choice={{ ...choice }}
          option={option}
          selectedOptions={selectedOptions}
          controlOptions={controlOptions}
          containerWidth={containerWidth}
          discountAmount={discountAmount}
          productQuantity={productQuantity}
          productUsedComponents={productUsedComponents}
          editedProduct={editedProduct}
          groupID={groupID}
          optionKey={optionKey}
        />
      </Grid>
    ));
    const conditionalChoices = option.choices.map((choice) => {
      const isChoiceSelected = this.props.checkChoiceSelected(
        choice.id,
        choice.option,
        groupID ?? groupID
      );
      const conditionalOptions = this.props.getConditionalOptions(
        choice.id,
        choice.option
      );
      return (
        <div className={` ${isChoiceSelected ? "" : "hidden"}`}>
          {conditionalOptions?.map((op) => (
            <div key={op.id}>
              <ProductOptionGroup
                key={op.id}
                option={op}
                controlOptions={controlOptions}
                selectedOptions={selectedOptions}
                themeColor={themeColor}
                discountAmount={discountAmount}
                productQuantity={productQuantity}
                productUsedComponents={productUsedComponents}
                editedProduct={editedProduct}
                editMode={this.props.editMode}
                inInGroup={false}
                sortOrder={op.sort_order}
                groupID={groupID}
              />
            </div>
          ))}
        </div>
      );
    });

    return (
      <>
        <Grid
          direction={language === "arabic" && "row-reverse"}
          container
          className="my-3 mx-1"
          justify={(choices.length === 1 && "center") || "space-between"}
          ref={this.container}
        >
          {choices}
        </Grid>
        <div>{conditionalChoices}</div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return { language: state.store.language };
};

export default connect(mapStateToProps)(OptionGroupGrid);
